import React, { useState } from "react";
import { ButtonGroup, NavDropdown, Button, Form } from "react-bootstrap";
import Banner from "../Banner/Banner";
import Stay from '../Stay/Stay'
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';





import Exclusive from "../Exclusive/Exclusive";
import Trending from "../Trending/Trending";
import CreateSell from "../CreateSell/CreateSell";
import Resources from "../Resources/Resources";
import Explore from "../Explore/Explore";
import Featured from "../Featured/Featured";
import Artists from "../Artists/Artists";
import LogoSlider from '../LogoSlider/LogoSlider'

function Header() {
   
    
    
    return (

        <div className="main-wrapper">
            <Banner/>
            <Exclusive/>
            <Trending/>
            <CreateSell/>
            <Resources/>
            <Explore/>
            <Featured/>
            <Artists/>
            <Stay/>
            <LogoSlider/>
        </div>

    )
}
export default Header;